import "./Header.css";
import SearchBar from "./Searchbar";
import { useNavigate } from "react-router-dom";

export default function Header({ onMenuClick }) {
  const navigate = useNavigate();

  return (
    <div className="header">
      <div className="header-actions">
        <button
          className="btn add-new"
          onClick={() => navigate("/new-expense")}
        >
          New Expense
        </button>

        <SearchBar onMenuClick={onMenuClick} />
      </div>
    </div>
  );
}
